import apiClient from "./api";
import { DijikolayCustomer } from "../redux/reducers/dijikolay/dijikolay.types";

const API_PREFIX = '/api/dijikolay';

export const getDijikolayCustomers = async (): Promise<{ data: { customers: DijikolayCustomer[] } }> => {
    return await apiClient.get(`${API_PREFIX}/customers`);
};

export const updateDijikolayStatus = async (id: number, status: string): Promise<{ data: { dijikolay: DijikolayCustomer } }> => {
    return await apiClient.put(`${API_PREFIX}/set-customer-status/${id}`, { status });
};

export const updateDijikolayContacted = async (id: number): Promise<{ data: { dijikolay: DijikolayCustomer } }> => {
    return await apiClient.put(`${API_PREFIX}/customers/${id}`);
};

export const updateDijikolayResponsible = async (id: number, responsible: string): Promise<{ data: { dijikolay: DijikolayCustomer } }> => {
    return await apiClient.put(`${API_PREFIX}/set-customer-responsible/${id}`, { responsible });
};